/* ==========================================================================
   MaxGlows — mobile checkout-path fixes                        2026-08-31
   Pairs with assets/maxglows-fixes.css

   Three jobs, in order of how much money they cost:

   1. SUPPRESS THE FLASHY POPUP ONCE THERE IS SOMETHING IN THE CART.
      Reproduced on 2026-08-31: tapping "הוספה להזמנה" opens the cart drawer
      and Flashy's "קיבלת 15% הנחה להזמנה ראשונה" popup lands on top of it,
      covering the line item, the price and the checkout button. The shopper
      has to find a small × before they can pay — and the offer itself makes
      no sense to someone who has already chosen a product. Straight cart
      abandonment. Flashy renders into a <flashy-popup> host with a shadow
      root, so there is nothing to target from CSS: the element is removed
      instead, and only while the cart is non-empty. A visitor with an empty
      cart still gets the popup, which is what it is actually for.

   2. Toggle body.mg-has-cart once the cart is not empty and body.mg-cart-open
      while the drawer is open (see the CSS for what each one hides and why).

   3. Toggle body.mg-sticky-atc, and publish the sticky bar's real height as
      --mg-sticky-h, while the product page's sticky add-to-cart bar is up.

   No theme file is modified; this only reacts to state the theme already
   exposes (cart-drawer.active, .sticky-atc, /cart.js).
   ========================================================================== */

(function () {
  'use strict';

  /* window.MG_CART_COUNT is seeded from Liquid in theme.liquid so the very
     first popup — which can fire before any fetch resolves — is already
     judged against the real cart. */
  function cartCount() {
    var n = window.MG_CART_COUNT;
    return typeof n === 'number' && n >= 0 ? n : 0;
  }
  function setCount(n) {
    if (typeof n === 'number' && n >= 0) window.MG_CART_COUNT = n;
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c.item_count; })
      .catch(function () { return cartCount(); });
  }

  /* Any cart mutation the theme (or an app) makes goes through fetch or XHR.
     Rather than guessing which buttons matter, watch the requests. */
  var CART_WRITE = /\/cart\/(add|change|update|clear)/;
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (CART_WRITE.test(url)) {
        p.then(function () { setTimeout(refreshCount, 80); })
         .catch(function () {});
      }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url || ''))) {
      this.addEventListener('load', function () { setTimeout(refreshCount, 80); });
    }
    return origOpen.apply(this, arguments);
  };

  /* ------------------------------------------------------------------ */

  function drawerOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active'));
  }

  /* The drawer only opens with something in it, so either condition alone is
     enough — both are checked because the count can lag a redirect-free add
     by a few dozen milliseconds. */
  function shouldSuppressPopup() {
    return cartCount() > 0 || drawerOpen();
  }

  function killFlashy() {
    if (!shouldSuppressPopup()) return;
    document.querySelectorAll('flashy-popup').forEach(function (el) { el.remove(); });
    /* Some Flashy builds leave the scroll lock behind when the host is
       removed mid-animation; make sure the page is still scrollable. */
    if (document.body.style.overflow === 'hidden' && !drawerOpen()) {
      document.body.style.overflow = '';
    }
  }

  /* ------------------------------------------------------------------ */

  function stickyState() {
    var sa = document.querySelector('.sticky-atc');
    if (!sa) return false;
    var r = sa.getBoundingClientRect();
    if (r.height === 0) return false;
    /* "on screen" = its top edge is above the fold by more than a sliver */
    var visible = r.top < window.innerHeight - 8 && r.bottom > 0;
    if (visible) {
      document.documentElement.style.setProperty('--mg-sticky-h', Math.round(r.height) + 'px');
    }
    return visible;
  }

  var lastCart = null, lastSticky = null, lastHas = null;

  function sync() {
    killFlashy();

    /* Owner's rule (31.8): the moment there is something in the cart, the
       WhatsApp bubble and the accessibility launcher go away for the rest of
       the visit — they were covering the checkout button and reading as
       clutter once the shopper had already chosen. */
    var has = cartCount() > 0;
    if (has !== lastHas) {
      document.body.classList.toggle('mg-has-cart', has);
      lastHas = has;
    }

    var open = drawerOpen();
    if (open !== lastCart) {
      document.body.classList.toggle('mg-cart-open', open);
      lastCart = open;
    }

    var sticky = !open && stickyState();
    if (sticky !== lastSticky) {
      document.body.classList.toggle('mg-sticky-atc', sticky);
      lastSticky = sticky;
    }
  }

  /* React to anything that changes the DOM (the drawer re-renders wholesale
     on every cart change, and Flashy injects its host the same way). */
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; sync(); }, 0);
  }

  new MutationObserver(queue).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style']
  });
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(sync, 250); });

  /* A safety net: Flashy can schedule its popup on a timer, and a mutation
     that happens between observer callbacks would otherwise slip through. */
  var ticks = 0;
  var iv = setInterval(function () {
    sync();
    if (++ticks > 120) clearInterval(iv);   /* 2 minutes, then observers only */
  }, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  refreshCount().then(sync);
})();
